import { Button, Tooltip } from 'antd';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { pushHistory } from '@/infrastructure/history';

export const TapdTips: FC = (props) => {
  const history = useHistory();
  const gotoTapd = () => pushHistory(history, 'setting/product-config?tab=tapd');

  return <Tooltip
    color='#fff'
    overlayInnerStyle={{ width: '300px' }}
    title={
      <div style={{ color: 'black', display: 'flex', alignItems: 'center' }}>
        请先完善TAPD配置，然后再提单
        <Button
          type='link'
          onClick={gotoTapd}
        >
          去完善
        </Button>
      </div>}
  >
    {props.children}
  </Tooltip>;
};
